import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'send',
  feedType: 'information',
  includeDate: false,
  includeLinks: false,
  includePrompts: false,
  includeActions: false,
  includeMfe: false,
};

export default defaults;
